export default __webpack_public_path__ + "static/media/icono-reloj.8308eb50.svg";